import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/goodsorder/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/goodsorder/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 删除
export function deleteById (id) {
  return request.get(`/business/goodsorder/delete/${id}`)
}

// 详情
export function getDetail (id) {
  return request.get(`/business/goodsorder/${id}`)
}

// 退款
export function backGoodsorder (data) {
  return request.post('/business/goodsorder/backGoodsorder', data, {
    trim: true
  })
}
// 退款
export function closerGoodsorder (id) {
  return request.post('/business/goodsorder/closerGoodsorder', {id})
}
// 获取可退款信息
export function getGoodsorderCanBanlanceDTO (params) {
  return request.get('/business/goodsorder/getGoodsorderCanBanlanceDTO', {params})
}
